<script>
import { ajax } from '../modules/helpers'
import { Modal } from '../modules/modals'

export default {
    name:     'calculator',
    data:     function () {
        return {
            values: {
                platform_size:     0,
                material:          0,
                elevation_size:    0,
                railing_size:      0,
                railing:           0,
                privacy_wall:      0,
                privacy_wall_size: 0,
                number_of_stairs:  0,
                options:           {
                    deck_permit:              false,
                    basic_lights_package:     false,
                    deck_skirting:            false,
                    removal_of_existing_deck: false,
                    deck_fascias:             false,
                },
            },
            fields: {
                deck_platform:         {
                    materials: [],
                },
                deck_elevation:        {
                    materials: [],
                },
                deck_railing:          {
                    materials: [],
                },
                deck_privacy_wall:     {
                    materials: [],
                },
                deck_number_of_stairs: {
                    prices: [],
                },
                deck_options:          {
                    deck_permit:              {},
                    basic_lights_package:     {},
                    deck_skirting:            {},
                    removal_of_existing_deck: {},
                    deck_fascias:             {},
                },
            },
            form: {
                first_name: '',
                last_name: '',
                phone: '',
                email: ''
            },
            confirmation: {
                url: '/thank-you-for-your-request/'
            }
        }
    },
    computed: {
        elevation_coefficient() {
            if (this.values.elevation_size >= 11) return .3
            if (this.values.elevation_size >= 8) return .2
            if (this.values.elevation_size >= 5) return .1

            return 0
        },

        costs_platform() {
            let material = this.fields.deck_platform.materials[this.values.material]
            return material ? this.values.platform_size * Number(material.price) : 0
        },
        costs_elevation() {
            return Number(this.costs_platform * this.elevation_coefficient)
        },
        costs_railing() {
            let material = this.fields.deck_railing.materials[this.values.railing]
            return material ? this.values.railing_size * Number(material.price) : 0
        },
        costs_privacy_wall() {
            let material = this.fields.deck_privacy_wall.materials[this.values.privacy_wall]
            return material ? this.values.privacy_wall_size * Number(material.price) : 0
        },
        costs_stairs() {
            let material_price = this.fields.deck_number_of_stairs.prices[this.values.material]
            return material_price ? this.values.number_of_stairs * Number(material_price.price) : 0
        },
        costs_option_deck_permit() {
            return this.values.options.deck_permit
                ? Number(this.fields.deck_options.deck_permit.price)
                : 0
        },
        costs_option_basic_lights_package() {
            return this.values.options.basic_lights_package
                ? Number(this.fields.deck_options.basic_lights_package.price)
                : 0
        },
        costs_option_deck_skirting() {
            return this.fields.deck_options.deck_skirting.prices && this.values.options.deck_skirting
                ? Math.ceil(
                    3
                    * Math.sqrt(this.values.platform_size)
                    * (this.elevation_coefficient + 1)
                    * Number(this.fields.deck_options.deck_skirting.prices[this.values.material].price),
                )
                : 0
        },
        costs_option_removal_of_existing_deck() {
            return this.values.options.removal_of_existing_deck
                ? Number(this.fields.deck_options.removal_of_existing_deck.price)
                : 0
        },
        costs_option_deck_fascias() {
            return this.fields.deck_options.deck_fascias.prices && this.values.options.deck_fascias
                ? Math.ceil(
                    3
                    * Math.sqrt(this.values.platform_size)
                    * Number(this.fields.deck_options.deck_fascias.prices[this.values.material].price),
                )
                : 0
        },
        costs_total() {
            return this.costs_platform
                + this.costs_elevation
                + this.costs_railing
                + this.costs_privacy_wall
                + this.costs_stairs
                + this.costs_option_deck_permit
                + this.costs_option_basic_lights_package
                + this.costs_option_deck_skirting
                + this.costs_option_removal_of_existing_deck
                + this.costs_option_deck_fascias
        },
        modal_text() {
            let text  = '';

            if(this.values.platform_size) {
                text += `<br />Platform ${this.values.platform_size} (${this.fields.deck_platform.materials[this.values.material].title})`
            }

            if(this.values.elevation_size) {
                text += `<br />Elevation ${this.values.elevation_size}`
            }

            if(this.values.railing_size) {
                text += `<br />Railing ${this.values.railing_size} (${this.fields.deck_railing.materials[this.values.railing].title})`
            }

            if(this.values.privacy_wall_size) {
                text += `<br />Privacy Wall ${this.values.privacy_wall_size} (${this.fields.deck_privacy_wall.materials[this.values.privacy_wall].title})`
            }

            if(this.values.number_of_stairs) {
                text += `<br />Stairs ${this.values.number_of_stairs}`
            }

            if(this.values.options.deck_permit) {
                text += `<br />Deck Permit`
            }

            if(this.values.options.basic_lights_package) {
                text += `<br />Basic Light Package`
            }

            if(this.values.options.deck_skirting) {
                text += `<br />Deck Skirting`
            }

            if(this.values.options.removal_of_existing_deck) {
                text += `<br />Deck Removal`
            }

            if(this.values.options.deck_fascias) {
                text += `<br />Deck Fascias`
            }

            return text;
        }
    },
    methods:  {
        async get_data() {
            let response = await ajax('calculator_get_data')
            this.fields  = response.data

            this.values.platform_size     = Number(this.fields.deck_platform.min)
            this.values.elevation_size    = Number(this.fields.deck_elevation.min)
            this.values.railing_size      = Number(this.fields.deck_railing.min)
            this.values.privacy_wall_size = Number(this.fields.deck_privacy_wall.min)
        },
        floating_enable_disable() {
            const observer = new IntersectionObserver((entries, opts) => {
                entries.forEach(entry => {
                        this.$refs['floating'].style.display = entry.isIntersecting ? 'none' : 'block'
                    },
                )
            }, {
                root: null, threshold: .01,
            })

            observer.observe(document.querySelector('.calculator .bottom'))
        },
        open_modal() {
            this.$refs.modal.control.open();
        },
        async submit() {
            this.$refs.submit.setAttribute('disabled', 'disabled')

            await ajax('calculator_submit', {
                form: {...this.form},
                text: this.modal_text
            });

            this.$refs.submit.removeAttribute('disabled')
            console.log('redirect');
            window.location = this.confirmation.url;

            this.$refs.submit.innerText = 'Thank you!'

            setTimeout(() => {
                this.$refs.submit.innerText = 'Send'
            }, 5000)
        },
    },
    mounted() {
        this.get_data()
        this.floating_enable_disable()

        qAll('.modal').forEach(el => !el.control && (el.control = new Modal(el)));

    },
}

</script>

<template>
    <div class="calculator">

<!--        <div v-html="modal_text"></div>-->

        <!--        DECK PLATFORM -->
        <div v-if="fields.deck_platform.title">
            <h2 class="font-h4">{{ fields.deck_platform.title }}</h2>
            <p>{{ fields.deck_platform.description }}</p>
        </div>
        <div class="range-wrapper" v-if="fields.deck_platform.title">
            <div class="caption">Enter Platform Size (sq. feet)</div>
            <div class="min">Min. {{ fields.deck_platform.min }} sq. feet</div>
            <div class="max">Max. {{ fields.deck_platform.max }} sq. feet</div>
            <div class="value">{{ values.platform_size }} sq. feet</div>
            <delta-range-slider v-model="values.platform_size" :min="fields.deck_platform.min"
                                :max="fields.deck_platform.max"></delta-range-slider>
        </div>
        <div class="options-wrapper">
            <template v-for="(material, index) in fields.deck_platform.materials">
                <input type="radio" name="deck_material" v-model="values.material" :value="index"
                       :id="'deck_material_' + index" style="display: none">
                <label class="option option--radio" :for="'deck_material_' + index">
                <span class="center">
                    <span class="title">{{ material.title }}</span>
                    <span class="description">{{ material.description }}</span>
                </span>
                    <img :src="material.image" :alt="material.title">
                </label>
            </template>
        </div>

        <!--        DECK ELEVATION-->
        <div v-if="fields.deck_elevation.title">
            <h2 class="font-h4">{{ fields.deck_elevation.title }}</h2>
            <p>{{ fields.deck_elevation.description }}</p>
        </div>
        <div class="range-wrapper" v-if="fields.deck_elevation.title">
            <div class="caption">Enter Average Deck Height (feet)</div>
            <div class="min">Min. {{ fields.deck_elevation.min }} feet</div>
            <div class="max">Max. {{ fields.deck_elevation.max }} feet</div>
            <div class="value">{{ values.elevation_size }} feet</div>
            <delta-range-slider v-model="values.elevation_size" :min="fields.deck_elevation.min"
                                :max="fields.deck_elevation.max"></delta-range-slider>
        </div>

        <!--        DECK RAILING-->
        <div v-if="fields.deck_railing.title">
            <h2 class="font-h4">{{ fields.deck_railing.title }}</h2>
            <p>{{ fields.deck_railing.description }}</p>
        </div>
        <div class="range-wrapper" v-if="fields.deck_railing.title">
            <div class="caption">Enter Total Length Of Railing (feet)</div>
            <div class="min">Min. {{ fields.deck_railing.min }} feet</div>
            <div class="max">Max. {{ fields.deck_railing.max }} feet</div>
            <div class="value">{{ values.railing_size }} feet</div>
            <delta-range-slider v-model="values.railing_size" :min="fields.deck_railing.min"
                                :max="fields.deck_railing.max"></delta-range-slider>
        </div>
        <div class="options-wrapper">
            <template v-for="(material, index) in fields.deck_railing.materials">
                <input type="radio" name="deck_railing" v-model="values.railing" :value="index"
                       :id="'deck_railing_' + index" style="display: none">
                <label class="option option--radio" :for="'deck_railing_' + index">
                <span class="center">
                    <span class="title">{{ material.title }}</span>
                    <span class="description">{{ material.description }}</span>
                </span>
                    <img :src="material.image" :alt="material.title">
                </label>
            </template>
        </div>

        <!--        PRIVACY WALL-->
        <div v-if="fields.deck_privacy_wall.title">
            <h2 class="font-h4">{{ fields.deck_privacy_wall.title }}</h2>
            <p>{{ fields.deck_privacy_wall.description }}</p>
        </div>
        <div class="range-wrapper" v-if="fields.deck_privacy_wall.title">
            <div class="caption">Enter Total Length Of Railing (feet)</div>
            <div class="min">Min. {{ fields.deck_privacy_wall.min }} feet</div>
            <div class="max">Max. {{ fields.deck_privacy_wall.max }} feet</div>
            <div class="value">{{ values.privacy_wall_size }} feet</div>
            <delta-range-slider v-model="values.privacy_wall_size" :min="fields.deck_privacy_wall.min"
                                :max="fields.deck_privacy_wall.max"></delta-range-slider>
        </div>
        <div class="options-wrapper">
            <template v-for="(material, index) in fields.deck_privacy_wall.materials">
                <input type="radio" name="deck_privacy_wall" v-model="values.privacy_wall" :value="index"
                       :id="'deck_privacy_wall_' + index" style="display: none">
                <label class="option option--radio" :for="'deck_privacy_wall_' + index">
                <span class="center">
                    <span class="title">{{ material.title }}</span>
                    <span class="description">{{ material.description }}</span>
                </span>
                    <img :src="material.image" :alt="material.title">
                </label>
            </template>
        </div>

        <!--        NUMBER OF STAIRS-->
        <div v-if="fields.deck_number_of_stairs.title">
            <h2 class="font-h4">{{ fields.deck_number_of_stairs.title }}</h2>
            <p>{{ fields.deck_number_of_stairs.description }}</p>
        </div>
        <div class="range-wrapper" v-if="fields.deck_number_of_stairs.title">
            <div class="caption">Enter the number of your stairs (assume 42" length, material matching decking)</div>
            <div class="min">Min. {{ fields.deck_number_of_stairs.min }} stairs</div>
            <div class="max">Max. {{ fields.deck_number_of_stairs.max }} stairs</div>
            <div class="value">{{ values.number_of_stairs }} stairs</div>
            <delta-range-slider v-model="values.number_of_stairs" :min="fields.deck_number_of_stairs.min"
                                :max="fields.deck_number_of_stairs.max"></delta-range-slider>
        </div>

        <!--        OPTIONS -->
        <div v-if="fields.deck_options.title">
            <h2 class="font-h4">{{ fields.deck_options.title }}</h2>
            <p>{{ fields.deck_options.description }}</p>
        </div>
        <div class="options-wrapper">

            <!--            OPTION DECK PERMIT-->
            <input type="checkbox" v-model="values.options.deck_permit"
                   id="deck_option_1" style="display: none">
            <label class="option option--checkbox" for="deck_option_1">
                <span class="center">
                    <span class="title">{{ fields.deck_options.deck_permit.title }}</span>
                    <span class="description">{{ fields.deck_options.deck_permit.description }}</span>
                </span>
                <img :src="fields.deck_options.deck_permit.image" :alt="fields.deck_options.deck_permit.title">
            </label>

            <!--            OPTION BASIC LIGHT PACKAGE-->
            <input type="checkbox" v-model="values.options.basic_lights_package"
                   id="deck_option_2" style="display: none">
            <label class="option option--checkbox" for="deck_option_2">
                <span class="center">
                    <span class="title">{{ fields.deck_options.basic_lights_package.title }}</span>
                    <span class="description">{{ fields.deck_options.basic_lights_package.description }}</span>
                </span>
                <img :src="fields.deck_options.basic_lights_package.image"
                     :alt="fields.deck_options.basic_lights_package.title">
            </label>

            <!--            OPTION DECK SKIRTING-->
            <input type="checkbox" v-model="values.options.deck_skirting"
                   id="deck_option_3" style="display: none">
            <label class="option option--checkbox" for="deck_option_3">
                <span class="center">
                    <span class="title">{{ fields.deck_options.deck_skirting.title }}</span>
                    <span class="description">{{ fields.deck_options.deck_skirting.description }}</span>
                </span>
                <img :src="fields.deck_options.deck_skirting.image"
                     :alt="fields.deck_options.deck_skirting.title">
            </label>

            <!--            OPTION REMOVAL OF EXISTING DECK-->
            <input type="checkbox" v-model="values.options.removal_of_existing_deck"
                   id="deck_option_4" style="display: none">
            <label class="option option--checkbox" for="deck_option_4">
                <span class="center">
                    <span class="title">{{ fields.deck_options.removal_of_existing_deck.title }}</span>
                    <span class="description">{{ fields.deck_options.removal_of_existing_deck.description }}</span>
                </span>
                <img :src="fields.deck_options.removal_of_existing_deck.image"
                     :alt="fields.deck_options.removal_of_existing_deck.title">
            </label>

            <!--            OPTION DECK FASCIAS-->
            <input type="checkbox" v-model="values.options.deck_fascias"
                   id="deck_option_5" style="display: none">
            <label class="option option--checkbox" for="deck_option_5">
                <span class="center">
                    <span class="title">{{ fields.deck_options.deck_fascias.title }}</span>
                    <span class="description">{{ fields.deck_options.deck_fascias.description }}</span>
                </span>
                <img :src="fields.deck_options.deck_fascias.image"
                     :alt="fields.deck_options.deck_fascias.title">
            </label>
        </div>
        <div class="bottom font-h6">
            <div v-if="costs_platform">Deck Platform: ${{ Intl.NumberFormat('fr-FR').format(costs_platform) }}</div>
            <div v-if="costs_elevation">Elevation: ${{ Intl.NumberFormat('fr-FR').format(costs_elevation) }}</div>
            <div v-if="costs_railing">Railing: ${{ Intl.NumberFormat('fr-FR').format(costs_railing) }}</div>
            <div v-if="costs_privacy_wall">Privacy Wall: ${{ Intl.NumberFormat('fr-FR').format(costs_privacy_wall) }}</div>
            <div v-if="costs_stairs">Stairs: ${{ Intl.NumberFormat('fr-FR').format(costs_stairs) }}</div>
            <div v-if="costs_option_deck_permit">Deck Permit: ${{ Intl.NumberFormat('fr-FR').format(costs_option_deck_permit) }}</div>
            <div v-if="costs_option_basic_lights_package">Basic Lights Package: ${{ Intl.NumberFormat('fr-FR').format(costs_option_basic_lights_package) }}</div>
            <div v-if="costs_option_deck_skirting">Deck Skirting: ${{ Intl.NumberFormat('fr-FR').format(costs_option_deck_skirting) }}</div>
            <div v-if="costs_option_removal_of_existing_deck">Removal Of Existing Deck: ${{ Intl.NumberFormat('fr-FR').format(costs_option_removal_of_existing_deck) }}</div>
            <div v-if="costs_option_deck_fascias">Deck Fascias: ${{ Intl.NumberFormat('fr-FR').format(costs_option_deck_fascias) }}</div>
            <div class="total font-h4">Total cost: ${{ Intl.NumberFormat('fr-FR').format(costs_total) }}</div>
        </div>

        <div class="button-order-wrapper">
            <button class="button" @click="open_modal">Send to Sales</button>
        </div>

        <div class="total-floating" ref="floating">
            <div class="container">
                <div class="total font-h6">Total cost: ${{ Intl.NumberFormat('fr-FR').format(costs_total) }}</div>
                <button class="button" @click="open_modal">Send to Sales</button>
            </div>
        </div>

        <div class="modal modal--center modal--sm" id="modal-calculator-form" ref="modal">
            <div class="modal-outer">
                <div class="modal-inner">
                    <button class="close" data-close></button>
                    <div class="modal-calculator-form">
                        <h3 class="font-h4">Fill out your contact details and we will contact you</h3>
                        <form action="">
                            <input type="text" v-model="form.first_name" placeholder="First Name">
                            <input type="text" v-model="form.last_name" placeholder="Last Name">
                            <input type="text" v-model="form.phone" placeholder="Phone">
                            <input type="text" v-model="form.email" placeholder="Email">
                        </form>
                        <button @click="submit" class="button" ref="submit">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

:global(#page-calculator > .container) {
    padding-bottom: 0;
}

.calculator {
    padding-bottom: 50px;
}

.options-wrapper {
    display: grid;
    gap: 30px;
    align-items: start;

    @media all and (min-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.option {
    display: grid;
    grid-template-columns: 1fr 60px;
    padding: 12px 16px;
    gap: 10px;
    border: 1px solid var(--color-gray);
    border-radius: 8px;
    cursor: pointer;

    .title {
        display: block;
        font-weight: 500;
    }

    .description {
        font-size: 12px;
        line-height: 130%;
    }

    .center {
        display: grid;
        gap: 6px;
        position: relative;
        padding-left: 26px;

        &::before, &::after {
            display: block;
            position: absolute;
            content: '';
        }

        &::before {
            top: 2px;
            left: 0;
            width: 16px;
            height: 16px;
            border: 1px solid var(--color-gray);
        }
    }

    img {
        width: 100%;
        height: 40px;
    }

    input:checked + & {
        border-color: var(--color-green);

        .center::before {
            border-color: var(--color-green);
        }

        &--checkbox .center {
            &::after {
                background-image: url('data:image/svg+xml;charset=UTF-8,<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 6L4 9L9 1" stroke="%2370BB1A" stroke-linecap="round" stroke-linejoin="round"/> </svg> ')
            }
        }

        &--radio .center::after {
            background-color: var(--color-green);
        }
    }

    &--checkbox {
        .center {
            &::before {
                border-radius: 4px;
            }

            &::after {
                top: 4px;
                left: 3px;
                width: 11px;
                height: 11px;
                background-size: cover;
            }
        }
    }

    &--radio {
        .center {
            &::before {
                border-radius: 50%;
            }

            &::after {
                top: 6px;
                left: 4px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }
        }
    }
}

.calculator {
    display: grid;
    gap: 30px;
}

.range-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    padding: 22px 16px;
    border-radius: 8px;
    border: 1px solid var(--color-gray);
    margin-bottom: 20px;

    .caption {
        top: 0;
        transform: translateY(-50%);
        left: 20px;
        padding: 0 3px;
        background-color: white;
        max-width: 80%;
    }

    .caption, .min, .max {
        position: absolute;
        color: var(--color-gray);
        font-size: 13px;
    }

    .min, .max {
        top: calc(100% + 5px);
    }

    .min {
        left: 0;
    }

    .max {
        right: 0;
    }

    .value {
        flex-shrink: 0;
        min-width: 100px;
        margin-right: 15px;
        font-size: 18px;
    }
}

h2 {
    margin-bottom: 12px;
}

.bottom {
    text-align: right;

    .total {
        margin-top: 15px;
    }
}

.button-order-wrapper {
    display: flex;
    justify-content: center;
}

.total-floating {
    position: sticky;
    bottom: 0;

    .total {
        font: 600 20px var(--font-1)
    }

    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 30px;
        background-color: var(--color-green-light-light);
        border: 1px solid var(--color-green);
        box-shadow: 0px -8px 8px 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px 8px 0 0;

    }
}

.modal-calculator-form {
    display: grid;
    gap: 30px;

    h3 {
        text-align: center;
    }

    form {
        display: grid;
        gap: 30px;
    }

    input, textarea {
        width: 100%;
        padding: 16px 10px;
        max-width: 100%;
        border-radius: 8px;
        border: 1px solid var(--color-gray);
        background-color: var(--color-gray-005);
        font: var(--font-input);
    }

    button {
        margin: 0 auto
    }
}


</style>
